import { ActionIcon, Progress } from "@mantine/core";
import Text from "../Text";
import classes from "./index.module.css";
import { Close, File, FileImage } from "../Icons";
import prettyBytes from "pretty-bytes";
import { formatNumber } from "@/utils/formatters";

interface Props {
  label: string;
  removeLabel: string;
  progressValue: number;
  showCancel: boolean;
  onCancel: () => void;
  fileSize?: number | null;
}

const FileBox = ({ label, removeLabel, progressValue, showCancel, onCancel, fileSize }: Props) => {
  const isPdf = label.toLowerCase().endsWith("pdf");

  return (
    <div className={classes.root}>
      <div className={classes.inner}>
        {isPdf ? <File className={classes.fileIcon} /> : <FileImage className={classes.fileIcon} />}
        <Text variant="reading" className={classes.label}>
          {label}
        </Text>
        {progressValue !== 100 ? (
          <Text variant="reading_bold">{formatNumber(progressValue)} %</Text>
        ) : (
          fileSize && (
            <Text variant="reading_medium" color="neutral.6">
              {prettyBytes(fileSize, { maximumFractionDigits: 1 })}
            </Text>
          )
        )}
        {showCancel && (
          <ActionIcon variant="transparent" size="md" onClick={onCancel} className={classes.closeIcon} aria-label={removeLabel}>
            <Close />
          </ActionIcon>
        )}
      </div>
      {progressValue !== 100 && (
        <Progress
          value={progressValue}
          radius="xs"
          size="xs"
          classNames={{ section: classes.progressSection }}
          aria-hidden="true"
        />
      )}
    </div>
  );
};

export default FileBox;
